import { useState } from "react";

import { InputAccessModal } from "@/components/common/modals/input-access-modal";

import AppearanceModal from "../shared/appearance";
import CurrentDate from "../shared/current-date";
import DisableInput from "../shared/disable";
import FitTextControl from "../shared/fit-text";
import GroupByInput from "../shared/group-by";
import HiddenInput from "../shared/hidden";
import NoEditInput from "../shared/no-edit";
import ReadOnlyInput from "../shared/read-only";
import Relation from "../shared/relations";
import RequiredInput from "../shared/required";
import AcceptedFiles from "./accepted-file";
import AccessInput from "./access";
import CalendarType from "./calendar-type";
import ConvertToSelect from "./convert-to-select";
import DateInputType from "./date-type";
import PlaceholderInput from "./placeholder";
import InputValidation from "./validation";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
  rightClickedElement: HTMLElement;
}

const InputContextActions: React.FC<Props> = ({
  editorRef,
  rightClickedElement
}) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const inputElement = rightClickedElement as
    | HTMLInputElement
    | HTMLTextAreaElement;

  const inputId = inputElement.id || inputElement.name || "";

  const isDate = rightClickedElement.getAttribute("data-input-type") === "date";
  return (
    <>
      <AccessInput
        inputElement={inputElement}
        onOpenAccessModal={() => setIsAccessModalOpen(true)}
      />
      <ConvertToSelect
        editorRef={editorRef}
        rightClickedElement={rightClickedElement}
      />
      <RequiredInput rightClickedElement={rightClickedElement} />
      <PlaceholderInput rightClickedElement={rightClickedElement} />
      <AppearanceModal
        editorRef={editorRef}
        rightClickedElement={rightClickedElement}
        title="ظاهر"
        description="تنظیم رنگ، فونت، ترازبندی و اندازه ورودی"
      />
      <FitTextControl rightClickedElement={rightClickedElement} />
      <GroupByInput rightClickedElement={rightClickedElement} />
      <DisableInput rightClickedElement={rightClickedElement} />
      <ReadOnlyInput rightClickedElement={rightClickedElement} />
      <NoEditInput rightClickedElement={rightClickedElement} />
      <HiddenInput rightClickedElement={rightClickedElement} />
      <Relation
        editorRef={editorRef}
        rightClickedElement={rightClickedElement}
      />
      <InputValidation rightClickedElement={rightClickedElement} />
      <AcceptedFiles rightClickedElement={rightClickedElement} />
      {isDate && <CurrentDate rightClickedElement={rightClickedElement} />}
      {isDate && <DateInputType rightClickedElement={rightClickedElement} />}
      {isDate && <CalendarType rightClickedElement={rightClickedElement} />}

      <InputAccessModal
        isOpen={isAccessModalOpen}
        inputId={inputId}
        input={inputElement}
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};
export default InputContextActions;
